<template>
  <v-dialog v-model="dialog" max-width="1240px">
    <v-card>
      <form @submit.prevent="">
        <v-card-title class="pb-0">
          <v-container style="max-width: 100%" class="pt-0 pb-0">
            <v-row>
              <v-col>
                <p class="headline mb-0" style="width: 100%">
                  {{ mess.dialog_create_lead_articles_title }}
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  v-model="query"
                  @keyup.enter="search('query')"
                  outlined
                  dense
                  hide-details
                  :label="mess['search_label']"
                  class="articles-search"
                >
                  <template v-slot:append>
                    <v-btn depressed color="#e4e4e4" height="26" class="mr-1">
                      <v-icon size="18" color="#999">mdi-file</v-icon>
                      <span
                        class="text-truncate"
                        style="max-width: 120px; font-size: 12px; font-weight: 400; text-transform: none; color: #999; letter-spacing: 0"
                        >{{ file ? file.name : mess["load_file"] }}</span
                      >
                      <v-file-input
                        v-model="file"
                        @change="search('file')"
                        class="articles-file-input"
                        style="width: 100%; position: absolute; cursor: pointer; opacity: 0; padding: 0;
  height: 30px;
  margin: 0;"
                        hide-details
                      ></v-file-input>
                    </v-btn>
                    <v-btn
                      @click="search('query')"
                      depressed
                      color="primary"
                      min-width="26"
                      width="26"
                      height="26"
                    >
                      <v-icon size="20" color="white">search</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-title>
        <v-card-text>
          <v-container class="pt-8" style="max-width: 100%">
            <v-row>
              <v-col cols="auto" class="pr-0 pb-0">
                <v-btn
                  depressed
                  tile
                  color="primary"
                  :outlined="!isTabSearchResult"
                  @click="isTabSearchResult = true"
                  >{{ mess.dialog_create_lead_tab_search_result }} ({{
                    articles.length
                  }})</v-btn
                >
              </v-col>
              <v-col cols="auto" class="pl-0 pb-0">
                <v-btn
                  depressed
                  tile
                  color="primary"
                  :outlined="isTabSearchResult"
                  @click="isTabSearchResult = false"
                  >{{ mess.dialog_create_lead_tab_deal_list }} ({{
                    articlesDeal.length
                  }})</v-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <article-legend
                  :legend="[
                    'assembly',
                    'have-analog',
                    'on-store',
                    'analog-on-store',
                    'in-transit',
                    'sales-draw',
                    'file'
                  ]"
                ></article-legend>
                <market-area-filter
                  v-if="marketAreaFilters"
                  :filters="marketAreaFilters"
                  :active-filters="marketArea"
                  @change-filter="onChangeMarketAreaFilter"
                ></market-area-filter>
              </v-col>
            </v-row>
            <template v-if="isTabSearchResult">
              <v-row>
                <v-col cols="12" style="height: 48vh; overflow-y: scroll">
                  <create-lead-articles-search-table
                    :selected-articles.sync="selected"
                    :articles="articles"
                    :headers="articleHeaders"
                    :available-list-loading="availableListLoading"
                    :market-area="marketArea"
                    @add-to-cart:article="addToCartSingleItem"
                    @update:selected="selected = $event"
                    @remove:article="removeArticle($event, articles, selected)"
                  ></create-lead-articles-search-table>
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-row>
                <v-col cols="12" style="height: 48vh; overflow-y: scroll">
                  <create-lead-articles-search-table
                    :selected-articles.sync="selectedDeal"
                    :articles="articlesDeal"
                    :headers="articleHeaders"
                    :available-list-loading="availableListLoading"
                    :market-area="marketArea"
                    @add-to-cart:article="addToCartSingleItem"
                    @update:selected="selectedDeal = $event"
                    @remove:article="
                      removeArticle($event, articlesDeal, selectedDeal)
                    "
                  ></create-lead-articles-search-table>
                </v-col>
              </v-row>
            </template>
          </v-container>
        </v-card-text>
        <v-card-actions v-if="!isTabSearchResult" style="padding: 0 24px 16px">
          <v-btn
            class="mb-3"
            style="text-transform: unset; font-weight: 700; letter-spacing: 0"
            :disabled="articlesDeal && articlesDeal.length === 0"
            outlined
            color="primary"
            depressed
            @click="generateXlsx"
            >{{ mess.dialog_base_button_download_xlsxl }}</v-btn
          >
          <v-btn
            class="mb-3"
            style="text-transform: unset; font-weight: 700; letter-spacing: 0"
            :disabled="(articlesDeal && articlesDeal.length === 0) || loading"
            outlined
            color="primary"
            depressed
            @click="resetDeal"
            >{{ mess.dialog_base_button_clear_deal }}</v-btn
          >
          <v-btn
            class="mb-3"
            style="text-transform: unset; font-weight: 700; letter-spacing: 0"
            :disabled="(articlesDeal && articlesDeal.length === 0) || loading"
            outlined
            color="primary"
            depressed
            @click="addToCart(articlesDeal)"
            >{{ mess.dialog_base_button_add_all_to_cart }} ({{
              articlesDeal.length
            }})</v-btn
          >
          <v-btn
            class="mb-3"
            style="text-transform: unset; font-weight: 700; letter-spacing: 0"
            :disabled="selectedDeal.length === 0 || loading"
            outlined
            color="primary"
            depressed
            @click="addToCart(selectedDeal)"
            >{{ mess.dialog_base_button_add_selected_to_cart }} ({{
              selectedDeal.length
            }})</v-btn
          >
        </v-card-actions>
        <v-card-actions v-if="isTabSearchResult" style="padding: 0 24px 16px">
          <v-btn
            class="mb-3"
            style="text-transform: unset; font-weight: 700; letter-spacing: 0"
            :disabled="articles && articles.length === 0"
            outlined
            color="primary"
            depressed
            @click="generateXlsx"
            >{{ mess.dialog_base_button_download_xlsxl }}</v-btn
          >
          <v-btn
            class="mb-3"
            style="text-transform: unset; font-weight: 700; letter-spacing: 0"
            :disabled="(articles && articles.length === 0) || loading"
            outlined
            color="primary"
            depressed
            @click="addToDeal(articles)"
            >{{ mess.dialog_base_button_add_all_to_deal }} ({{
              articles.length
            }})</v-btn
          >
          <v-btn
            class="mb-3"
            style="text-transform: unset; font-weight: 700; letter-spacing: 0"
            :disabled="selected.length === 0 || loading"
            outlined
            color="primary"
            depressed
            @click="addToDeal(selected)"
            >{{ mess.dialog_base_button_add_selected_to_deal }} ({{
              selected.length
            }})</v-btn
          >
        </v-card-actions>
        <v-btn absolute top right text icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </form>

      <v-row>
        <create-lead-accept-file
          style="z-index: 1000"
          :is-visible.sync="createLeadAcceptFile"
          @clear-file="file = null"
          @search="_search('file')"
        >
        </create-lead-accept-file>
      </v-row>

      <v-overlay :value="overlay" absolute color="white" opacity="0.5">
        <v-progress-circular
          indeterminate
          size="64"
          color="primary"
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </v-dialog>
</template>

<script>
// Components
import CreateLeadAcceptFile from "@/components/dialogs/CreateLeadAcceptFile";
import CreateLeadArticlesSearchTable from "./createLeadArticlesSearchTable";
import ArticleLegend from "@/components/ArticleLegend";
import MarketAreaFilter from "@/components/MarketAreaFilter/MarketAreaFilter";

// Services
import { cartService } from "@/services/cart-service/cart-service";

// API
import { searchArticles } from "@/api/my-customers";

// Models
import createSearchData from "@/models/createSearchData";
import notifications from "@/models/notificationTemplates";

// Utils
import unionWith from "lodash/unionWith";
import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";
import createUniqID from "@/utils/create-uniq-id";
import Xlsx from "@/utils/create-xlsx-data";

export default {
  name: "CreateLeadArticlesSearchDialog",
  components: {
    CreateLeadAcceptFile,
    CreateLeadArticlesSearchTable,
    ArticleLegend,
    MarketAreaFilter
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    sm: {
      type: Boolean,
      default: false
    },
    exportFields: {
      type: Array,
      default: () => []
    },
    articleHeaders: {
      type: Array,
      default: () => []
    },
    searchQuery: {
      type: String,
      default: ""
    },
    searchFile: {
      type: File,
      default: null
    },
    company: {
      type: String,
      default: ""
    },
    marketAreaFilters: {
      type: [Array, null],
      default: () => null
    }
  },
  data() {
    return {
      createLeadAcceptFile: false,
      isTabSearchResult: true,
      articles: [],
      articlesDeal: [],
      selected: [],
      selectedDeal: [],
      dialog: false,
      overlay: false,
      loading: false,
      query: undefined,
      file: null,
      marketArea: [],
      availableListLoading: false,
      headers: [
        {
          header: "Наименование",
          key: "name"
        },
        {
          header: "Артикул",
          key: "code"
        },
        {
          header: "ОЕМ Артикул",
          key: "oem"
        },
        {
          header: "Наличие",
          key: "available"
        },
        {
          header: "Цена",
          key: "price"
        }
      ]
    };
  },
  methods: {
    onChangeMarketAreaFilter(evt) {
      if (this.marketArea.includes(evt)) {
        if (this.marketArea.length === 1) return;
        this.availableListLoading = true;
        this.marketArea.splice(this.marketArea.indexOf(evt), 1);
      } else {
        this.availableListLoading = true;
        this.marketArea.push(evt);
      }

      setTimeout(() => {
        this.availableListLoading = false;
      }, 250);
    },
    setInitialMarketArea() {
      this.marketArea = cloneDeep(this.marketAreaFilters || []);
    },
    _search(type) {
      this.overlay = true;
      this.isTabSearchResult = true;
      this.resetData();
      const { file } = this;
      searchArticles(createSearchData(type, { file }))
        .then(articles => {
          this.articles = articles.map(a => ({
            ...a,
            _uniqID: createUniqID()
          }));
        })
        .catch(() => {
          this.$emit("error", notifications.error.base);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    search(type) {
      if (
        type === "file" &&
        (this.file.name.lastIndexOf(".xls") === -1 ||
          this.file.name.lastIndexOf(".xlsx") === -1)
      )
        return (this.createLeadAcceptFile = true);

      this.overlay = true;
      this.isTabSearchResult = true;
      if (type === "query") this.file = null;
      this.resetData();
      const { file, query } = this;
      searchArticles(createSearchData(type, { file, query }))
        .then(articles => {
          this.articles = articles.map(a => ({
            ...a,
            _uniqID: createUniqID()
          }));
        })
        .catch(() => {
          this.$emit("error", notifications.error.base);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    addToDeal(items) {
      this.articlesDeal = unionWith(this.articlesDeal, items, isEqual);
      this.isTabSearchResult = false;
      this.selected = [];
    },
    addToCartSingleItem(item) {
      cartService
        .addArrayItemsToCart([item])
        .then(data => {
          if (data.success) {
            this.$emit(
              "added-to-cart-single-item",
              notifications.success.addToCart
            );
          } else {
            this.$emit("error", notifications.error.base);
          }
        })
        .catch(() => {
          this.$emit("error", notifications.error.base);
        });
    },
    addToCart(items) {
      this.loading = true;
      cartService
        .addArrayItemsToCart(items)
        .then(data => {
          if (data.success) {
            this.$emit("added-to-cart");
          } else {
            throw new Error();
          }
        })
        .catch(err => {
          throw err;
        })
        .finally(() => (this.loading = false));
    },
    removeArticle(item, articles, selected) {
      articles.splice(articles.indexOf(item), 1);

      const indexInSelected = selected.indexOf(item);
      if (indexInSelected !== -1) selected.splice(indexInSelected, 1);
    },
    resetForm() {
      this.overlay = false;
      this.resetData();
    },
    resetData() {
      this.articles = [];
      this.selected = [];
    },
    resetDeal() {
      this.articlesDeal = [];
      this.selectedDeal = [];
    },
    async generateXlsx() {
      const xlsx = new Xlsx(this.headers, this.articles);
      const simpleSheet = xlsx.createSimpleSheet();

      await xlsx.generateXlsx(this.company, simpleSheet);
    }
  },
  watch: {
    isVisible(val) {
      this.dialog = val;
    },
    dialog(val) {
      this.$emit("update:is-visible", val);
      this.$nextTick(() => {
        if (val && !!this.file) {
          this.search("file");
        } else if (val) {
          this.search("query");
        } else if (!val) {
          this.file = null;
          this.resetForm();
          this.resetDeal();
        }
      });
    },
    file(val) {
      this.$emit("update:search-file", val);
    },
    searchQuery(val) {
      this.query = val;
    },
    searchFile(val) {
      this.file = val;
    },
    query(val) {
      this.$emit("update:search-query", val);
    }
  },
  created() {
    this.setInitialMarketArea();
  }
};
</script>

<style lang="scss">
.articles-search button {
  overflow: hidden;
}

.create-lead-articles-table.v-data-table {
  thead tr {
    vertical-align: baseline;
    line-height: 1;
  }

  th {
    padding-top: 8px;
    padding-bottom: 8px;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    text-transform: uppercase;
    font-size: 10px;
    font-weight: 500;
    line-height: 1.4;
    color: #9c9c9c;
  }

  td {
    font-size: 12px;
    color: #000000;
  }

  .v-input__slot {
    min-height: 32px !important;
  }
}
.v-tab--active.v-tab:not(:focus)::before {
  opacity: 0.12;
}
.articles-search .v-file-input__text {
  width: 100%;
  max-width: 100px;
  padding: 0 !important;
  height: 30px !important;
  margin: 0 !important;
  cursor: pointer;
}
</style>
